import MKpi from './MKpi.vue';

MKpi.install = (app) => {
  app.component('MKpi', MKpi);
};

export { MKpi };
